<template>
  <div v-if="page" class="overflow-hidden relative">
    <img
      :srcset="heroPictureSrcSet"
      :alt="page.name"
      class="absolute z-[-1] inset-0 w-full h-full object-cover"
    />
    <div class="container py-8 lg:py-12">
      <div class="bg-white w-full max-w-[648px] mt-4 lg:mt-8 p-8 lg:p-12">
        <h3
          class="text-jva-blue-500 text-[32px] leading-10 sm:text-5xl sm:leading-[56px] font-bold mb-4"
        >
          D'autres organisations cherchent des bénévoles {{ page.readable_name }}
        </h3>
        <p class="text-[#3A3A3A] mb-8 text-lg sm:text-xl leading-7 sm:leading-8">
          {{ page.name }} regorge d'<strong>associations dynamiques et engagées</strong> qui
          participent à la vie locale
        </p>

        <DsfrButton :to="`/associations/${page.slug}`" class="w-full lg:w-auto">
          Découvrir les associations <span class="hidden lg:inline">{{ page.readable_name }}</span>
        </DsfrButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { organisation } = defineProps<{
  organisation: Organisation
}>()

const { page, heroPictureSrcSet } = useAssociationsVille(organisation.city)
</script>
